import { useShopI18n } from '../i18n/ShopI18n'
import type { ShopPromotions } from '../services/shopApi'

export default function FirstPurchaseBanner({ promotion }: { promotion: ShopPromotions }) {
    const { t } = useShopI18n()
    return <section className="shop-first-purchase" aria-label={t('Erstkauf-Bonus')}>
        <div className="shop-first-badge"><img src="/assets/webshop/first-purchase-badge.svg" alt="" /><b>{promotion.firstPurchaseBonusPercent}%</b></div>
        <div className="shop-first-copy"><b>{t('{{percent}}% Bonus auf deinen ersten Kauf!', { percent: promotion.firstPurchaseBonusPercent })}</b><span>{t('Nur hier im Shop. Ausgenommen Plus Calendar.')}</span></div>
        <div className="shop-first-character"><img src="/assets/webshop/first-purchase-character.png" alt="" /></div>
    </section>
}
